import { lazyLoadComponentSilent, loadBundle } from '../../../../services/LazyLoadComponent';

export default lazyLoadComponentSilent(() => import(/* webpackChunkName: 'ClippyTrigger' */ '.').then(loadBundle));
